export const rowStyles = {}
export const actionRowStyle = { paddingTop: 15 }
export const hrStyle = { height: ' 1px', backgroundColor: 'var(--gray-200)', border: 'none' }
export const rowStyleGray = { backgroundColor: 'light-gray' }
export const rowStyleFlex = {
  display: 'flex',
}

// TODO: get from BE to populate dropdown
export const ReasonCodes = [
  'Supply Unavailable',
  'Driver Utilization',
  'Road Closures',
  'Prevent Runout',
  'Terminal Down',
  'Allocation not Met',
  'Driver not Carded',
  'Current Directive Requires Volume',
  'No Volume Remaining on Optimal Directive',
  'Other',
]

export const CPH_FLAG = 'counterparty_hold'
export const RESOLVE_FLAG_TYPES = ['optimal_supply', 'counterparty_hold']
